/*
 * Copyright (c) 2018. CPP, Inc. All rights reserved.
 * Also protected by Patent Pending: 15/916,593
 */

const photoNavigation = rawData => rawData.all.map(({ photo }) => photo.fields)

export default photoNavigation
